/*!
 * Sticky hero text — versione "sticky nativo", zero calcoli per frame.
 *
 * PERCHE' QUESTO CAMBIO DI APPROCCIO:
 * ".hero__content__wrapper" vive dentro ".slideshow__slide", che e' figlio
 * di ".flickity-slider" — l'elemento che Flickity trasla orizzontalmente
 * con "transform: translateX()" per far scorrere le slide. Qualsiasi
 * antenato con un transform applicato disabilita "position: sticky" nativo
 * del CSS per tutti i suoi discendenti (limite del browser, non di
 * Shopify). Le versioni precedenti di questo script simulavano lo sticky
 * ricalcolando la posizione via JS ad ogni fotogramma di scroll:
 * funzionante e matematicamente corretto, ma con un residuo di scatto
 * intrinseco a QUALSIASI sticky simulato via JS.
 *
 * QUESTA VERSIONE elimina il problema alla radice: sposta fisicamente
 * ".hero__content__wrapper" di ogni slide FUORI dalla catena trasformata
 * da Flickity, in un contenitore "overlay" che e' fratello di
 * <slider-component>, non piu' suo discendente. Una volta fuori da quella
 * catena, "position: sticky" nativo (definito nel CSS) funziona come da
 * standard: gestito interamente dal compositor del browser.
 *
 * FIX RESIZE FLICKITY: rimuovere ".hero__content__wrapper" da dentro ogni
 * slide cambia leggermente la larghezza che Flickity ha già misurato per
 * quella cella al proprio avvio. Se non lo si dice a Flickity, lui
 * continua ad animare le slide in base alla misura vecchia (stantia),
 * creando un micro-vuoto visibile — che rivela lo sfondo della sezione
 * sotto — SOLO durante l'animazione della transizione (mai a riposo,
 * verificato dal vivo). Per questo, subito dopo aver spostato i wrapper,
 * chiamiamo "sliderComponent.flkty.resize()" (l'istanza di Flickity che
 * il componente del tema espone su ".flkty") per fargli ri-misurare le
 * celle con la struttura DOM finale.
 *
 * SINCRONIZZAZIONE SLIDE ATTIVA: invece di ascoltare un evento "select"
 * dispatchato dal componente (non garantito — verificato non funzionare:
 * il testo restava sempre quello della prima slide anche quando l'immagine
 * sotto cambiava), osserviamo direttamente i cambi di classe su ogni
 * ".slideshow__slide" con un MutationObserver. Flickity aggiunge/rimuove
 * la classe "is-selected" sulla slide attiva — verificato funzionare
 * sempre — quindi osservarlo direttamente è il modo più robusto.
 *
 * Attivo solo da desktop (>=990px): su mobile il testo resta dove è
 * sempre stato, centrato via "align--middle-center-mobile", senza sticky.
 *
 * RIUSO SU ALTRI BLOCCHI: lo stesso pattern (spostare l'elemento sticky
 * fuori da qualsiasi antenato con transform, poi lasciare fare tutto al
 * CSS nativo, forzando un resize del carosello dopo il DOM move,
 * sincronizzando lo stato "attivo" via MutationObserver sulla classe che
 * il carosello già gestisce) si applica identico a qualsiasi altro
 * blocco/carosello — cambiano solo i selettori qui sotto.
 */
(function () {
  'use strict';

  function isDesktop() {
    return window.matchMedia('(min-width: 990px)').matches;
  }

  function initSection(section) {
    if (!isDesktop()) return;
    if (section.__stickyMounted) return;

    var sliderComponent = section.querySelector('slider-component');
    if (!sliderComponent) return;

    section.__stickyMounted = true;

    var overlay = document.createElement('div');
    overlay.className = 'sticky-text-overlay';
    sliderComponent.insertAdjacentElement('afterend', overlay);

    var slides = Array.prototype.slice.call(section.querySelectorAll('.slideshow__slide'));

    slides.forEach(function (slide, index) {
      var wrapper = slide.querySelector('.hero__content__wrapper');
      if (!wrapper) return;
      wrapper.setAttribute('data-slide-index', index);
      overlay.appendChild(wrapper); // sposta il nodo, non lo copia
    });

    // Fix vuoto durante le transizioni: dopo aver spostato i wrapper,
    // le celle di Flickity potrebbero avere una larghezza cambiata
    // rispetto a quella già misurata al proprio avvio. Forziamo la
    // ri-misurazione con la struttura DOM finale.
    if (sliderComponent.flkty && typeof sliderComponent.flkty.resize === 'function') {
      sliderComponent.flkty.resize();
    }

    var wrappers = Array.prototype.slice.call(overlay.querySelectorAll('.hero__content__wrapper'));

    function syncActiveText() {
      var activeIndex = slides.findIndex(function (slide) {
        return slide.classList.contains('is-selected');
      });
      wrappers.forEach(function (wrapper) {
        var isActive = Number(wrapper.getAttribute('data-slide-index')) === activeIndex;
        wrapper.classList.toggle('is-active-slide-text', isActive);
      });
    }

    syncActiveText();

    // Meccanismo primario e affidabile: osserva i cambi di classe delle slide
    // (Flickity aggiunge/rimuove "is-selected" sulla slide attiva ad ogni
    // cambio, questo è verificato funzionare sempre).
    var observer = new MutationObserver(syncActiveText);
    slides.forEach(function (slide) {
      observer.observe(slide, { attributes: true, attributeFilter: ['class'] });
    });

    // Ridondanza innocua: se il componente dispatcha comunque questi eventi,
    // li ascoltiamo anche, ma non ci basiamo solo su di essi.
    sliderComponent.addEventListener('select', syncActiveText);
    sliderComponent.addEventListener('settle', syncActiveText);

    section.__stickyObserver = observer;
  }

  function init() {
    document.querySelectorAll('.slideshow--sticky-text').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Se Shopify ricarica la sezione nell'editor tema, permette di rifare il montaggio.
  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.slideshow--sticky-text');
    if (section) {
      if (section.__stickyObserver) section.__stickyObserver.disconnect();
      section.__stickyMounted = false;
      initSection(section);
    }
  });
})();